var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.element.statusConfig && _vm.element.statusConfig.isShow
      && _vm.judgingArchiAPermission(_vm.element.archiLimit, _vm.element.authConfig && _vm.element.authConfig.list, _vm.element)
			&& _vm.getUILogicStatus()
    )?_c('el-col',{staticClass:"component-box",style:(_vm.getBoxStyle(_vm.element)),attrs:{"data-id":_vm.element.id,"span":_vm.element.span !== undefined ? +_vm.element.span : -1}},[_c(_vm.element.component,{tag:"component",style:(_vm.getComStyle(_vm.element)),attrs:{"element":_vm.element,"containerData":_vm.containerData,"pageId":_vm.pageId}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }